module.exports = __webpack_public_path__ + "static/media/DIRAD.fa14a97d.svg";